class PriceHelper {
  private prices: any;
  DEFAULT_PRICES = {
    trialEligible: false,
    premium: {
      monthly: {
        priceFormatted: "$49",
        trialPeriod: 14,
        price: 49
      },
      annually: {
        priceFormatted: "$479",
        price: 479,
        trialPeriod: 31,
        annualSavings: `$${(49 * 12 - 479).toFixed(2)}`
      }
    },
    pro: {
      monthly: {
        priceFormatted: "$99",
        trialPeriod: 14,
        price: 99
      },
      annually: {
        priceFormatted: "$977",
        trialPeriod: 31,
        price: 977,
        annualSavings: `$${(99 * 12 - 977).toFixed(2)}`
      }
    },
    enterprise: {
      monthly: {
        priceFormatted: "from $199",
        price: 199
      },
      annually: {
        priceFormatted: "from $199",
        price: 199
      }
    }
  };

  constructor(prices: any) {
    this.prices = prices;
  }

  getPrices(): any {
    if (this.prices) {
      return this.prices;
    } else {
      return this.DEFAULT_PRICES;
    }
  }

  isTrialEligible(): boolean {
    const p = this.getPrices();
    return p.trialEligible || false;
  }

  trialPeriod(interval: string): number {
    if (this.isTrialEligible()) {
      const p = this.getPrices();
      return p["pro"][interval].trialPeriod || 0;
    }
    return 0;
  }

  // Define the signature for getPrice based on your needs.
  // For example, it might take a product name and return its price.
  getPrice(plan: string, interval: string): string {
    const p = this.getPrices();
    return p[plan][interval].priceFormatted;
  }

  getPriceToday(plan: string, interval: string): string {
    const p = this.getPrices();
    if (this.hasDiscount(plan, interval)) {
      return p[plan][interval].discount.price;
    } else {
      return this.getPrice(plan, interval);
    }
  }

  getTerm(plan: string, interval: string): string {
    const p = this.getPrices();
    return p[plan][interval].discount.term;
  }

  // Define the signature for getSavings based on your needs.
  // For example, it might take two product names and return the price difference.
  getSavings(plan: string, interval: string): string {
    if (plan === "enterprise") {
      return "Monthly";
    }
    const p = this.getPrices();
    if (this.hasDiscount(plan, interval)) {
      return `${p[plan][interval].discount.term}`;
    } else if (interval === "annually") {
      return `Save ${p[plan][interval].annualSavings}`;
    } else {
      return "Monthly";
    }
  }

  hasDiscount(plan: string, interval: string): boolean {
    if (plan === "enterprise") {
      return false;
    }
    const p = this.getPrices();
    return p[plan][interval].discount != undefined;
  }
}

export default PriceHelper;
